import { useQuery } from '@tanstack/react-query';
import { sessionGroupStore } from '../store/sessionGroupStore';
import {
  SESSION_GROUP_QUERY_GC_TIME,
  SESSION_GROUP_QUERY_STALE_TIME,
} from './constants';
import { sessionGroupsQueryKey } from './keys';

export const sessionGroupsListQueryOptions = () => ({
  queryKey: sessionGroupsQueryKey(),
  queryFn: () => sessionGroupStore.listGroups(),
  staleTime: SESSION_GROUP_QUERY_STALE_TIME,
  gcTime: SESSION_GROUP_QUERY_GC_TIME,
  refetchOnWindowFocus: false,
});

export const useSessionGroupsListQuery = () =>
  useQuery({
    ...sessionGroupsListQueryOptions(),
    placeholderData: previous => previous,
  });
